import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import { assetPinnedDownArrow, assetPinnedLeftArrow, assetPinnedRightArrow, assetPinnedUpArrow, } from '../../../assets.fwn';
import useSessionStorage from '../../../hooks/useSessionStorage';
const Content = styled.div `
  width: 100%;
  overflow: auto;

  ${(props) => props.isCollapsed &&
    `
    height: 0;
    width: 0;
    overflow: hidden;
    `}
`;
const PinnedHeader = styled('a') `
  color: inherit;
  font-size: 16px;
  line-height: 1.5;
  padding: 0 10px;
  text-decoration: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;
const PinnedHeaderText = styled('span') `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const PinnedLeft = styled.a `
  background-image: url('${(props) => props.showLeftNav ? assetPinnedLeftArrow : ''}');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 26px 26px;
  display: block;
  flex-basis: 40px;
  flex-grow: 0;
  &:hover {
    cursor: ${(props) => (props.showLeftNav ? 'pointer' : 'initial')};
  }
`;
const PinnedRight = styled('a') `
  background-image: url('${assetPinnedRightArrow}');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 26px 26px;
  display: block;
  flex-basis: 40px;
  flex-grow: 0;
`;
const CollapsePosition = styled('div') `
  min-width: 35px;
  height: 35px;
  position: absolute;
  right: 0;
  top: 0;
`;
const PinnedCollapse = styled.a `
  &:hover {
    color: inherit;
    text-decoration: none;
  }

  background-image: url('${assetPinnedDownArrow}');
  background-position: top right;
  background-repeat: no-repeat;
  background-size: contain;
  color: inherit;

  ${(props) => props.isCollapsed &&
    `
      padding-right: 35px;
      background-image: url('${assetPinnedUpArrow}');`};

  display: block;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
`;
export const PinnedWrapper = (props) => {
    const { children, onScrollLeft, onScrollRight, showLeftNav, title } = props;
    const { t } = useTranslation();
    const [isPinnedCollapsed, setIsPinnedCollapsed] = useSessionStorage('_fwnclpsd', false);
    const onPinnedCollapse = (event) => {
        event.preventDefault();
        setIsPinnedCollapsed(!isPinnedCollapsed);
    };
    const collapseArrow = (<PinnedCollapse href="#" isCollapsed={isPinnedCollapsed} onClick={onPinnedCollapse} title={isPinnedCollapsed ? t('Expand') : t('Collapse')}>
      {/* {!!isPinnedCollapsed && t('Expand')} */}
    </PinnedCollapse>);
    return (<Fragment>
      {isPinnedCollapsed && (<PinnedHeader title={t('Expand')} href="#" onClick={onPinnedCollapse}>
          <PinnedHeaderText className="cy-pinned-title">
            {title ? title : t('Recommended Videos made in Firework')}
          </PinnedHeaderText>
          {collapseArrow}
        </PinnedHeader>)}
      {!isPinnedCollapsed && (<CollapsePosition>{collapseArrow}</CollapsePosition>)}

      {!isPinnedCollapsed && (<PinnedLeft href="#" onClick={showLeftNav ? onScrollLeft : undefined} title={t('Left')} showLeftNav={showLeftNav}/>)}

      <Content isCollapsed={isPinnedCollapsed}>{children}</Content>

      {!isPinnedCollapsed && (<PinnedRight href="#" onClick={onScrollRight} title={t('Right')}/>)}
    </Fragment>);
};
